module.exports = __webpack_public_path__ + "static/img/facebook.8a844456.svg";